import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkboxContainer', 'checkbox']
  static values = { domains: { type: Array, default: [] } }

  toggle(event) {
    const email = event.target.value.toLowerCase()
    const domain = email.split('@')[1] || ''
    const isEsker = this.domainsValue.includes(domain)

    this.checkboxContainerTarget.classList.toggle('d-none', !isEsker)
    this.checkboxTarget.disabled = !isEsker
  }
}
